import React, { useEffect, useState } from "react";
import "../styles/CustomCursor.css";

const CustomCursor: React.FC = () => {
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [isDesktop, setIsDesktop] = useState(true);

    useEffect(() => {
        // Check if it's a mobile device
        const checkIfDesktop = () => {
            const isTouchDevice =
                "ontouchstart" in window || navigator.maxTouchPoints > 0;
            setIsDesktop(!isTouchDevice);
        };

        checkIfDesktop();

        const handleMouseMove = (e: MouseEvent) => {
            setPosition({ x: e.clientX, y: e.clientY });
        };

        if (isDesktop) {
            window.addEventListener("mousemove", handleMouseMove);
        }

        return () => {
            if (isDesktop) {
                window.removeEventListener("mousemove", handleMouseMove);
            }
        };
    }, [isDesktop]);

    if (!isDesktop) return null; // Don't render on mobile/tablet

    return (
        <div
            className="custom-cursor"
            style={{
                left: `${position.x}px`,
                top: `${position.y}px`,
            }}
        />
    );
};

export default CustomCursor;
